import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import {deleteActiveUsageSort, deleteActiveusageSort, setActiveUsageSort, setActiveusageSort} from "../../helpers/product";
import { isMobileOnly} from "react-device-detect";
import qs from "query-string";
import {useTranslation} from "react-i18next";

const ShopFitSize = ({ location, currentQuery, setCurrentQuery, fitsizes, getSortParams, isHome, setLoadingProducts }) => {
  const [isSmallScreen, setSmallScreen] = useState(false);
    const { t } = useTranslation()

  const query = qs.parse(location.search, {
      ignoreQueryPrefix: true
  });
  const filterButtons = document.querySelectorAll(
      ".sidebar-widget-tag-fitsize button"
  );

    filterButtons.forEach(item => {
        item.classList.remove("active");
    });

    if (query && query.fitSizes) {
        let fitSizes = query.fitSizes.split('_');
        fitSizes.map(size => {
            var element = document.getElementById("fitSize_"+size);
            if (element){
                element.classList.add("active")
            }
        })
    }

    useEffect(() => {
        const matchResult = window.matchMedia("(max-width: 992px)");
        if (matchResult.matches) {
            setSmallScreen(true)
        }
    }, [])

    window.addEventListener("resize", function() {
        if (window.matchMedia("(min-width: 992px)").matches) {
            setSmallScreen(false)
        }
    })

  return (
    <div className="sidebar-widget mt-10">
        {
            isMobileOnly || isSmallScreen ?
                <div>
                    <h4 className="pro-sidebar-title">{isHome ? "Quel taille de chausson ? (facultatif)" : "Taille chausson :"}&nbsp;</h4>
                    <div className="sidebar-widget-tag-fitsize mt-10" style={{display: 'block'}}>
                        {fitsizes ? (
                            <ul>
                                {fitsizes.map((fitsize, key) => {
                                    return (
                                        <li key={"fitSize_"+key}>
                                            <button
                                                className="toto"
                                                id={"fitSize_"+fitsize}
                                                onClick={e => {
                                                    setLoadingProducts(true)
                                                    if (e.currentTarget.classList.contains('active')) {
                                                        getSortParams("fitsize", "");
                                                        setCurrentQuery({ ...currentQuery, fitSizes: ""});
                                                        deleteActiveUsageSort(e);
                                                    } else {
                                                        getSortParams("fitsize", fitsize);
                                                        setCurrentQuery({ ...currentQuery, fitSizes: fitsize});
                                                        setActiveUsageSort(e);
                                                    }
                                                }}
                                            >
                                                {t(fitsize.toLowerCase())}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            "No tags found"
                        )}
                    </div>
                </div>
                :
                <div>
                    <h4 className="pro-sidebar-title">{isHome ? "Quel taille de chausson ? (facultatif)" : "Taille chausson :"}&nbsp;</h4>
                    <div className="sidebar-widget-tag-fitsize mt-10">
                        {fitsizes ? (
                            <ul>
                                {fitsizes.map((fitsize, key) => {
                                    return (
                                        <li key={"fitSize_"+key}>
                                            <button
                                                className="toto"
                                                id={"fitSize_"+fitsize}
                                                onClick={e => {
                                                    setLoadingProducts(true)
                                                    if (e.currentTarget.classList.contains('active')) {
                                                        getSortParams("fitsize", "");
                                                        setCurrentQuery({ ...currentQuery, fitSizes: ""});
                                                        deleteActiveUsageSort(e);
                                                    } else {
                                                        getSortParams("fitsize", fitsize);
                                                        setCurrentQuery({ ...currentQuery, fitSizes: fitsize});
                                                        setActiveUsageSort(e);
                                                    }
                                                }}
                                            >
                                                {t(fitsize.toLowerCase())}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            "No tags found"
                        )}
                    </div>
                </div>
        }
    </div>
  );
};

export function getLabel(usage, t){
    switch (usage){
        case "Women":
            return t('usage')
        case "Men":
            return "Homme"
        case "Unisex":
            return "Non Genré"
        default:
            return
    }
}

export function ConstructRemoveUsageQueryPath(query, sizeToRemove) {
    if (query && query.usages) {
        let usages = query.usages.split('_');
        usages = usages.filter(size => {
            return size !== sizeToRemove;
        })
        if (usages.length > 0) {
            let newSizeQuery = ""
            usages.map((size, index) => {
                if (index == 0){
                    newSizeQuery += size
                } else {
                    newSizeQuery +=  "_" + size
                }
            })
            return newSizeQuery
        } else {
            return null
        }

    }
    return null
}

ShopFitSize.propTypes = {
  getSortParams: PropTypes.func,
  tags: PropTypes.array,
  currentQuery: PropTypes.object,
  setCurrentQuery: PropTypes.func,
    location: PropTypes.string
};

export default ShopFitSize;
